// Valore speciale per next_step_key (sia quello generico del pulsante che quello dentro
// outcomes): invece di puntare a un vero step del flusso, riporta il kiosk alla schermata
// iniziale vera e propria — layer 1 "voce" (avatar + microfono a tutto schermo), con reset
// completo di risposte/sessione — invece che al primo step del layer form. Distinto da
// FlowStep.is_start, che marca solo quale step del form viene mostrato per primo quando si
// entra nel layer 2 (dopo aver premuto "Inizia"), non la pagina iniziale del kiosk.
export const RETURN_TO_VOICE_KEY = "__voice__";
